import { UseQueryOptions, useQuery } from "@tanstack/react-query";

import { WeightingScheme } from "types";
import { WeightingSchemesAPI } from "api";

const queryKeys = {
  all: () => ["weighting-schemes"] as const,
  lists: () => [...queryKeys.all(), "list"] as const,
  listAll: () => [...queryKeys.lists(), "all"] as const,
};

/**
 * Fetches a list of WeightingScheme instances - typically used within a select search.
 */
export const useAllWeightingSchemes = <T = WeightingScheme[]>(
  options: UseQueryOptions<WeightingScheme[], unknown, T> = {},
  includeAccountDefault = false,
) =>
  useQuery<WeightingScheme[], unknown, T>(
    queryKeys.listAll(),
    () => WeightingSchemesAPI.getAll(includeAccountDefault),
    options,
  );
